import { render, staticRenderFns } from "./calendar-event-menu.vue?vue&type=template&id=1bac4c08"
import script from "./calendar-event-menu.vue?vue&type=script&lang=js"
export * from "./calendar-event-menu.vue?vue&type=script&lang=js"
import style0 from "./calendar-event-menu.vue?vue&type=style&index=0&id=1bac4c08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports